module.exports = __webpack_public_path__ + "static/AnastasiiaShyshak-67671f86bd7f13ef3d4f00f7b5f76e0a.jpeg";